module.exports = __webpack_public_path__ + "static/media/mmsys_110.88281eea.ico";